<template>
  <div class="warp">
          <headerBack :backParams="backParams" @backBtn="back()"></headerBack>
          <div id="mapBox"></div>
          <div  class="stationInfo" ref="remove">
              <!-- <div class="line-icon"></div> -->
              <!-- 站点名称 -->
              <div class="station">
                  <div class="stationName">
                      <div>
                          <img src="../../assets/image/stationLine.png">
                          <span>{{stationName}}</span>
                      </div>
                      <div style="font-size:12px;color:#333;padding-top:12px">
                        <span>当前站台距您约{{distanceStation}}米</span> <span style="padding-left:4px">{{sameStationLength}}个同名站台</span>
                      </div>
                  </div>
                  <div class="btnBox">
                    <div class="btn"><button @click = changeStation() type="primary" class="btnStyle">切换站台</button></div>
                  </div>
                  
              </div>
              <!-- 搜索框 -->
              <div class="searchInput" @click="toSeach()">
                  <van-icon class="searchIcon"  name="search"/>     
                   搜索目的地点  
              </div>
              <div class="lineList" ref="DOM">
                <!-- -==== -->
                <div class="lineInfo" v-for="(item,index) in lineInfoList" :key="index" @click="lineClick(item)">
                    
                    <!-- 即将到站 -->
                    <div v-if ="item.stationSep == 0">
                      <div class="lineTop commonBox">
                        <div class="lineName">{{item.lineName}}</div>
                         <div v-if="item.status == 0" class="lineTime">
                           <span class="unitStyle">下一班次</span>   
                       </div>
                      </div>
                      <div class="lineBottom commonBox">
                        <div class="lineDirection">
                           开往<span class="destination">{{item.lastStationName}}</span>
                        </div>
                        <div class="lineFar">
                           <span v-if="item.status == 0"> 
                             <div>预计{{item.departureTime}}发车</div>
                           </span>
                           <span v-if="item.status == 5" class="quickStation">--</span>
                           <span v-if="item.status == 1 || item.status == 2 ||item.status == 3 ||item.status == 4" class="quickStation">即将到站</span>
                        </div>
                      </div> 
                    </div>
                    <!-- 剩余几站 -->
                    <div v-else>
                      <div class="lineTop commonBox">
                        <div class="lineName">{{item.lineName}}</div>
                        <div class="lineTime">
                        <span class="timeNumber">{{item.runTime}}</span><span>{{item.timeUnit}}</span>
                        </div>
                      </div>
                      <div class="lineBottom commonBox">
                        <div class="lineDirection">
                          开往<span class="destination">{{item.lastStationName}}</span>
                         </div>
                         <div class="lineFar">
                          {{item.stationSep}}站/{{item.distance}}
                         </div>
                      </div> 
                    </div>
                </div>
              </div>
          </div>
  </div>
</template>
<script>
import AMap from 'AMap'
import headerBack from '@/components/headerBack'
import {setLocalStorage, getLocalStorage} from '@/utils/session.js'
export default {
  name:'stationDetails',
  components:{
    headerBack
  },
  data(){
      return{
         mapBox:'',
         latLng:{},
         currentStation:{},//当前站点
         allStation:[],//所有站点
         sameStationList:[],//同名站点
         stationIndex:0,
         station:{},
         lineInfoList:[],
         distanceStation:'',
         sameStationLength:'',
         stationName:'',
         imgUrl:'../../assets/image/stationLine.png',
         lineTimer:null,
         swiperOption: {
          observer: true,
          direction: "vertical", 
          slidesPerView: "auto",
          freeMode: true,
          scrollbar: {
            el: ".swiper-scrollbar"
          },
          mousewheel: true,
          on: {
            // 这里注册事件
          }
        },
        backParams:{
          title: '站点详情'
        },
         scrollHeight:0,
         tanslateNum:50,
         markersList:[]
      }
  },
  mounted(){
    //路由跳转,传递参数站点信息
     this.latLng = getLocalStorage('LatLng')
     this.stationParams =  this.$route.params.station || this.$session.getSession('station')
     //路由传递数据，存在session，防止刷新页面空白
     this.stationName=this.stationParams.stationName
     this.getMapStation()
     this.initMap()
     this.$wxHide()
   },
   beforeRouteLeave(to, from, next){
     next()
     clearInterval(this.lineTimer)
     this.lineTimer = null
   },
   methods:{
     beforeunloadFn() {
     
     },
     back () {
      this.$router.push({name:'home'})
     },
     //获取地图附近的站点
     getMapStation(){
        this.sameStationList =[]
        let  paramasLocation ={
            latitude:this.latLng.lat,
            longitude:this.latLng.lng
        }
        this.$api['station.mapStation'](paramasLocation).then(res => {
        if(res && res.length){
            //先匹配当前站点的所有方向的站牌
             this.allStation = res
             let stationSaneName = this.stationParams.stationName
             this.sameStationList  = res.filter(item=>{
               return item.stationName == stationSaneName
             })
             //同名站点的数量
             this.sameStationLength = this.sameStationList.length
             //当前站点
             this.currentStation = this.sameStationList[0]
             this.initData()
           }
        })
     },
     initData(){
       //当前站点距你的位置的距离
        this.stationName = this.currentStation.stationName
         let  paramasLocation ={
            latitude:this.latLng.lat,
            longitude:this.latLng.lng
        }
        let nowLocation = [paramasLocation.longitude,paramasLocation.latitude]
        let nowStation = [this.currentStation.longitude,this.currentStation.latitude]
        this.distanceStation= AMap.GeometryUtil.distance(nowLocation, nowStation).toFixed(0)
        //查询该站点下的线路
        this.getStationLine(this.currentStation)
        //初始化地图
        this.nearStation()
     },
     watchMapStation(){
         this.$router.push({name:"stationMap",params:{allStation:this.allStation,currentStation:this.currentStation}})
         this.$session.setSession('allStation',this.allStation)
         this.$session.setSession('currentStation',this.currentStation)
     },
       
     initMap() {
        this.mapBox = new AMap.Map('mapBox', {
            resizeEnable: true, //是否监控地图容器尺寸变化
            zoom:15, //初始化地图层级
            viewMode: '2D',  //设置地图模式
            lang:'zh_cn',  //设置地图语言类型
         });
         this.myMarker()
         this.mapBox.panBy(0,-400);
     },
     //
     myMarker(){
        let iconSelf = new AMap.Icon({
                size: new AMap.Size(30,30),
                image: require('../../assets/image/stationMarker.png'),
                imageSize: new AMap.Size(30,30) 
         });
         //我的位置
         let  paramasLocation ={
            latitude:this.latLng.lat,
            longitude:this.latLng.lng
        }
        let  marker = new AMap.Marker({
                position: [paramasLocation.longitude,paramasLocation.latitude],
                map: this.mapBox,
                icon: iconSelf,
                clickable :false,
          });
     },
     //切换站台
     changeStation(){
       if(this.stationIndex == this.sameStationList.length-1){
          this.stationIndex = -1
       }
       this.stationIndex=this.stationIndex+1
       this.currentStation = this.sameStationList[this.stationIndex]
       this.mapBox.clearMap()
       this.myMarker()
       this.initData()
     },
     getStationLine(item){
         let params = {
             directionType:item.directionType,
             latitude:item.latitude,
             longitude:item.longitude,
             stationId:item.stationId,
             stationName:item.stationName
         }
         this.$api['station.findLineByStation'](
           params
         ).then(res => {
            if(res && res.length){
             this.lineInfoList = res
             
            //  获取站点的所用线路信息当作参数
             const firstStationlineList = this.lineInfoList.map(item => {
                return Object.assign({}, {businessType:item.businessType ,dirctionType:item.dirctionType,lineCode: item.lineCode, lineType: item.lineType, lineStationId: item.lineStationId })
             })
             this.getLineTime(firstStationlineList)
             //一分钟更新一次数据
              this.lineTimer = setInterval(()=>{
               this.getLineTime(firstStationlineList);
              },1000*6)
            }
        })    
     },
     // 3.4 获取多条线路的最近两辆车辆到站情况
     getLineTime(firstStationlineList){
         this.$api['station.timetable'](firstStationlineList).then(res => {
                if (res && res.length) {
                      let arr = []
                      res.forEach(item=>{
                        arr.push(item.busPosition[0])
                      })
                     this.handLineTime(arr)
                      
                }
          })
     },
     //拿出线路时间 最近的一条的数据
     handLineTime(arr){
      this.lineInfoList=arr.map((item,index)=>{
         let  line = this.lineInfoList[index]
         const objItem = {
          runTime: (item.runTime * 1) >= 60 ?  (item.runTime * 1 / 60).toFixed(0)  : item.runTime ,
          timeUnit: (item.runTime * 1) >= 60 ?  "分钟" :'秒',
          distance: (item.distance * 1)>=1000 ? ((item.distance * 1)/1000).toFixed(1) + '公里': item.distance + '米',
          stationSep: item.seq ?  (line.seq * 1)- (item.seq * 1) : 0,
          status:item.status,
          departureTime:item.departureTime
          
         }
         return Object.assign({}, line,objItem)
       })
       
     },
     //根据经纬度来查询附近的站点
     nearStation(){
            let currentMarker = ''
            this.markersList = []
            let iconSelf = new AMap.Icon({
                size: new AMap.Size(18,18),
                image: require('../../assets/image/stationMarker.png'),
                imageSize: new AMap.Size(18,18) 
            });
            for (var i = 0, marker; i < this.allStation.length; i++) {
                var marker = new AMap.Marker({
                    position: [this.allStation[i].longitude ,this.allStation[i].latitude],//不同标记点的经纬度
                    map: this.mapBox,
                    icon: iconSelf,
                    clickable : true,
                  });
                  marker.setLabel({
                    content:`<div class='info'>${this.allStation[i].stationName}</div>`, //设置文本标注内容
                    direction: 'top' //设置文本标注方位
                  });
                  marker.stationName = this.allStation[i].stationName;
                  marker.stationId = this.allStation[i].stationId;
                  this.markersList.push(marker);
                  this.mapBox.add(this.markersList)
                   AMap.event.addListener(marker, 'click', (e)=> {
                    this.markersList.forEach(item=>{
                        if(item.stationId == e.target.stationId){
                            this.clickMarker(item)
                            
                        }
                    })
            
                  }) 
              }
             //把当前的位置
              currentMarker = this.markersList.filter(item=>{
                 return  this.currentStation.stationId ==item.stationId
              })[0]
               this.mapBox.setFitView(currentMarker);
               this.walkingLine()
               this.changeStyle(currentMarker)
               this.mapBox.panBy(0,-200);
        
     },
     //线路规划
     walkingLine(){
       var walkingOption = {} 
       var walking = new AMap.Walking(walkingOption)
       //根据起终点坐标规划步行路线
      let  paramasLocation ={
            latitude:this.latLng.lat,
            longitude:this.latLng.lng
        }
       let start =[paramasLocation.longitude,paramasLocation.latitude]
       let end =[this.currentStation.longitude,this.currentStation.latitude]
        walking.search(start,end,(status, result)=>{
         if (status === 'complete') {
            if (result.routes && result.routes.length) {
                 this.drawRoute(result.routes[0])
             }
          }else{
             
          } 
       });
     },
      drawRoute (route) {
        var path = this.parseRouteToPath(route)
        var routeLine = new AMap.Polyline({
            path: path,
            isOutline: true,
            outlineColor: '#ffeeee',
            borderWeight: 2,
            strokeWeight: 5,
            strokeColor: '#22B2ED',
            lineJoin: 'round'
        })
        routeLine.setMap(this.mapBox)
        //调整视野达到最佳显示区域
        // this.mapBox.setFitView([ startMarker, endMarker, routeLine ])
    },
    parseRouteToPath(route) {
      var path = []
      for (var i = 0, l = route.steps.length; i < l; i++) {
          var step = route.steps[i]
          for (var j = 0, n = step.path.length; j < n; j++) {
            path.push(step.path[j])
          }
      }
      return path
    },
     //点击站点
     clickMarker(current){
       this.mapBox.clearMap()
      //点击站点切换线路
       this.currentStation = this.allStation.filter(item=>{
        return item.stationId == current.stationId
       })[0]
       let stationSaneName = this.currentStation.stationName
        this.sameStationList  = this.allStation.filter(item=>{
            return item.stationName == stationSaneName
         })
        this.sameStationLength = this.sameStationList.length
       this.myMarker()
       this.initData()
     },
     //点击站点,更改样式
     changeStyle(current){
       this.markersList.forEach(item=>{
          item.setLabel({
                content:`<div class='info'>${item.stationName}</div>`, //设置文本标注内容
                direction: 'top' //设置文本标注方位
            });
       })
        current.setLabel({
                content:`<div class='infoActive'>${current.stationName}</div>`, //设置文本标注内容
                direction: 'top' //设置文本标注方位
        });
     },
     // 线路跳转
     lineClick(item){
        this.$router.push({name:"lineDetails",params:{line:item,flag:2}})
        this.$session.setSession('line',item)
     },
     toSeach(){
        this.$router.push({name:"searchStation"})
     },
  }
}
</script>
<style lang="scss" scoped>
    .warp{
        width: 100%;
        height: 100%;
        position: relative;
        // overflow: hidden;
        #mapBox{
         width: 100%;
         height: 100%;
         position: absolute;
        }
      .stationInfo{
          width: 100%;
          height:50vh;
          background:#ffffff;
          position: fixed;
          left: 0;
          bottom: 0;
          z-index: 10000;
          overflow:hidden;
          transition: transform .5s ease-out;
         .line-icon {
            width: 50px;
            height: 3px;
            border-radius: 1px;
            background: #e9e7ef;
            margin: 5px auto;
          }
        .station{
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0.1rem;
            .stationName{
               img{
                 width:0.26rem;
                 height:0.29rem;
                 padding-right:0.15rem;
                 position: relative;
                 top:0.12rem;
                 }
               font-size: 15px;
               color: #333;
              //  font-weight: 600;
             }
             .btnBox{
                 font-size: 12px;
                 .mapSee{
                   color:#22B2ED;
                   padding:0.12rem 0rem;
                   padding-left:0.15rem;
                 }
                 .btn{
                   .btnStyle{
                      border: none;
                      background: #22B2ED;
                      color: #fff;
                      border-radius: 14px;
                      padding: 4px 20px;
                      line-height: 18px;
                    }
                 }
                 
             }
           
             
               
            
        }
        .searchInput{
            background:#eee;
            margin:0rem 0.1rem;
            border-radius:10px;
            font-size:30px;
            padding:0.08rem 0rem;
            font-size:14px;
            color:#666;
            padding-left:0.1rem;
            .searchIcon{
              position:relative;
              top:3px;
            }
        }
        .lineList{
                padding: 0rem 0.2rem;
                margin-top: 0.1rem;
                // height: calc(50vh -1.8rem);
                 height:200px;
                overflow: auto;
            .lineInfo{
                 border-bottom: 1px solid #EEE;
                 align-items: center;
                 padding:0.05rem 0rem;
                .lineTop{
                  padding-bottom:0.1rem;
                  .lineName{
                     font-size:0.15rem;
                     font-weight:600;
                     color:#333;
                  }
                  .lineTime{
                    font-size:0.14rem;
                    color: #FF8056;
                    .timeNumber{
                       font-size:0.18rem;
                    }
                  }
                }
                .lineBottom{
                  
                   .lineDirection{
                     color:#666666;
                     font-size: 0.13rem;
                     .destination{
                         padding-left:0.1rem
                     }
                     
                   }
                   .lineFar{
                      color:#546AD9;
                      font-size: 0.14rem;
                      font-weight:600;
                   }
                   .noFar{
                      color:#FF8056;
                      font-size: 0.14rem;
                   }
                   .quickStation{
                       color:#FF8056;
                       font-size: 0.14rem;
                   }
                }
             };
             .lineInfo:last-child {
                border-bottom: none; 
             }
        }
        
        
      
      }
    }
    
  .commonBox{
     display: flex;
     justify-content: space-between;
     align-items: center;
   }
   .marginBox{
     margin-top:0.1rem
   }
  ::v-deep{
   .amap-marker-label{
     border-radius:4px;
     padding:0px;
     font-size:12px;
     border:1px solid #22B2ED;
    .info{
       color:#22B2ED!important;
       padding:3px 6px;
     }
    .infoActive{
      color:#fff!important;
      background-color:#22B2ED ;
      padding:3px 6px;
      border:1px solid #22B2ED
      
    }
   }
  }

    
   
</style>